<template>
  <Layout>
    <TableView slot="content" :columns="columns" :filters="filter" @action="action" :list="list"
      :server-total="total" @nextList="getList()" minWidth="900px">
      <div class="d-flex align-items-center position-relative me-3">
        <b-icon icon="search" />
        <input @change="listParams.searchKeyword = $event.target.value" class="form-control form-control-solid w-400px ps-11"
          :placeholder="$t('아이디, IP, 기기')" title="아이디, IP, 기기">
      </div>
    </TableView>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";

export default {
  components: { Layout, TableView, ModalForm },
  data: () => ({
    sel: {},
    list: [],
    total: 0,
    listNo: 1,
    columns: [
      // { key: 'logSeq', label: '#', hide: ['view'], style: { textAlign: 'center' } },
      { key: 'identifier', label: '식별자', form: 1, style: { textAlign: 'center' } },  // 추가
      { key: 'task', label: '수행업무', form: 1, renderer: item => item.task, style: { textAlign: 'center' } },  // 추가
      { key: 'successYn', label: '성공여부', form: 4, renderer: item => `<b class="badge ${({ Y: 'badge-light-success', N: 'badge-light-danger' })[item.successYn]}">${item.successYn == "Y" ? '성공' : '실패'}</b>`, style: { textAlign: 'center' } },
      { key: 'userIdText', label: '이용자 식별정보', form: 1, style: { textAlign: 'center' } },
      { key: 'loginDt', renderer: item => `${item.loginDt.f('datetime-local')}`, label: '접속일시', form: 2, style: { textAlign: 'center' }, width: 140 },
      { key: 'message', label: '사유', form: 5, style: { textAlign: 'center', maxWidth: '330px' }, width: 230 },
      { key: 'accessIp', label: '접속지', form: 6, style: { textAlign: 'center' } },
      { key: 'deviceInfo', label: '기기', form: 7, style: { textAlign: 'left' }, width: 350 },
    ],
    listParams: { searchKeyword:'', successYn:null },
    filter: [{ key:'successYn', label:'성공여부', cd:'SUCCESS' }],
    selected: 'loginDt',
    options: [
      { item: 'loginDt', name: '로그인 일시' },
    ]
  }),
  created() { this.getList(); },
  mounted() { },
  beforeDestroy() { },
  computed: {},
  watch: { listParams: { deep: true, handler: 'getList' } },
  methods: {
    async action({ action, item, form }) {
      if (!form && ['view', '수정'].includes(action)) {
        this.sel = item;
        return this.$nextTick(() => this.$bvModal.show(action));
      }
      if (!form && !(await this.$alert(this.$t('[$]님을 $ 하시겠습니까?', [item.userNm, action]), { confirm: true, title: action }))) return;
      const res = await this.$api(`adm/user/${({ 수정: 'updateUser', 추가: 'insertUser', 잠금: 'lockUser', '오류횟수 초기화': 'pwdErrCnt', '비밀번호 초기화': 'pwdReset', 삭제: 'deleteUser' })[action]}`, form || { userId: item.userId });
      await this.$alert(res.msg);
      if (res.success) this.getList(true);
    },
    /** 목록 데이터 수신 */
    async getList(reset) {
      if (reset != undefined) this.list = [];
      const {list, parameter:{total}} = await this.$api('adm/log/login/selectLoginLogList', { ...this.listParams, firstIndex: this.list.length + 1 });
      this.total = total;
      this.list.push(...list);
    },
  },
}
</script>
